/*
  Navigation Bar component
*/

import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { signOut } from 'aws-amplify/auth';
import { useNavigate } from 'react-router-dom'; 
import { Menu, MenuItem, Avatar } from '@mui/material';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import { AccountBalanceWallet, ExitToApp } from '@mui/icons-material';

const CustomAppBar = styled(AppBar)({
  backgroundColor: '#7c3bed', 
  maxHeight:'max-content',
  position:'static'
});

const CustomTypography = styled(Typography)({
  color: 'white',
  fontSize: '25px', 
  fontWeight: 'bold',
  paddingRight: '20px'
});


const Spacer = styled('div')({
  flexGrow: 1,
});

/* Avatar letter. This used to be userData["custom:firstName"].charAt(0), which
   guarded userData being null but NOT the attribute being absent -- so any
   account without custom:firstName (e.g. a freshly invited user, who only has
   email + custom:bucket) crashed the whole app on render with "Cannot read
   properties of undefined (reading 'charAt')" (2026-07-27). Falls back through
   first name -> email -> 'U'. */
export function avatarInitial(userData) {
  const first = userData?.['custom:firstName'];
  if (typeof first === 'string' && first.trim()) return first.trim()[0].toUpperCase();
  const email = userData?.email;
  if (typeof email === 'string' && email.trim()) return email.trim()[0].toUpperCase();
  return 'U';
}


function Navbar() {
  const navigate = useNavigate(); 
  const [ userData, setuserData ] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  async function handleSignOut() {
    await signOut({ global: true })
    localStorage.removeItem('userData');
    localStorage.removeItem('selectedDevice');
    navigate('/');
  }

  function getUserData(){
    const data = localStorage.getItem('userData');
    if (data) {
      setuserData(JSON.parse(data)); 
    }
  }

  useEffect(()=>{
    getUserData();
  },[])

  return (
    <CustomAppBar>
      <Toolbar>
        <CustomTypography variant="h6">
          MIRA
        </CustomTypography>
        <Button color="inherit" onClick={()=>{navigate('/dashboard')}}>Home</Button>
        <Button color="inherit" onClick={()=>{navigate('/team')}}>Teams</Button>
        <Button color="inherit" onClick={()=>{navigate('/setup')}}>Setup</Button>
        <Spacer/>
        <Avatar onClick={handleMenuOpen} sx={{ marginRight: '15px'}}>{avatarInitial(userData)}</Avatar>
        <Menu
          id="icon-menu"
          anchorEl={anchorEl}
          open={open}
          onClose={handleMenuClose}
        >
          {/* <MenuItem  onClick={()=>{navigate('/adduser')}}><GroupAddIcon sx={{ marginRight: '15px'}}/>Add Users</MenuItem> */}
          <MenuItem><AccountBalanceWallet sx={{ marginRight: '15px'}}/>Payment</MenuItem>
          <MenuItem onClick={handleSignOut}><ExitToApp sx={{ marginRight: '15px'}}/>Sign Out</MenuItem>
        </Menu>
      </Toolbar>
    </CustomAppBar>
  );
}

export default Navbar;